import React, { Component } from "react";

import { CCard, CCardBody, CButton } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import PageOfflineList from "../../../../components/OfflineRegister/PageOfflineList";
import ProtectedRoute from "../../../../components/ProtectedRoute";

class ListOfflineRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [],
      // loading: true,
      // statisticsModal: false,
      // selectedActivityId: null
    };
  }

  render() {
    return (
      <>
        <>
          <div className="botoes">
            <div className="d-flex">
              <div className="flex-1 d-flex justify-content-end align-items-center">
                <Breadcrumb current={this.props.currentRoute} />
                <div className="flex-1 d-flex justify-content-end align-items-center">
                  <CButton
                    color="primary"
                    onClick={() =>
                      this.props.history.push("/offline/register/create")
                    }
                    style={{ minWidth: "230px" }}
                  >
                    <i className="fa fa-plus mr-2"></i>Novo Registro Offline
                  </CButton>
                </div>
              </div>
            </div>
          </div>
          <hr className="mt-1 mb-4" />
        </>
        <div className="d-flex flex-column align-items-left">
          <CCard>
            <CCardBody>
              <PageOfflineList />
            </CCardBody>
          </CCard>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListOfflineRegister);
